import React, { useEffect, useState } from "react";
import Footer from "../../../Components/Footer/footer";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import LoadingPage from "../../../Components/layouts/loading";
import { useSelector } from "react-redux";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { FcMoneyTransfer } from "react-icons/fc";
import EmployeeSalaryTracking from "./employe_salary_tracking";
import DynamicFilterSelect from "../../../Components/layouts/filter.select";
import getFilteredURL from "../../../Components/Functions/filters.getUrl";
import DynamicFilterInput from "../../../Components/layouts/filter.inpit";
import { FaFileInvoiceDollar } from "react-icons/fa6";
import { TbAdjustmentsCheck } from "react-icons/tb";
import { useNavigate } from "react-router";
import { FcBusinessman } from "react-icons/fc";
import { Form, Formik } from "formik";
import {
  employeeSalaryInfo,
  salaryAdjustInfo,
  salaryAdjustSchema,
  salaryEmpInfoSchema,
} from "../../../Schemas/employee/salaryAdjust.schema";
import CustomSelect from "../../../CustomComponent/custom_select";
import CustomTextArea from "../../../CustomComponent/custom_textarea";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import CustomInput from "../../../CustomComponent/custom_input";
import { extractDate } from "../../../Components/Functions/date.fun";
import axios from "axios";

const EmployeeSalary = () => {
  const store = useSelector((store) => store?.login.user);
  const payroleCred = useSelector((store) => store?.payroleReducer.cred);
  const [refresh, setRefresh] = useState(false);
  const [page, setPage] = useState(1);
  const getPreviousMonth = () => {
    const now = new Date();
    now.setMonth(now.getMonth() - 1);
    const year = now.getFullYear();
    const month = (now.getMonth() + 1).toString().padStart(2, "0");
    return `${year}-${month}`;
  };
  const [filters, setFilters] = useState({
    startdate: "",
    enddate: "",
    userName: store?.Name,
    userId: store?.UserId,
    month: getPreviousMonth(),
  });
  const [username, setUserName] = useState(store?.Name);
  const [months, setMonth] = useState(getPreviousMonth());
  const navigate = useNavigate();
  const [attendanceData, setAttendanceData] = useState();
  const [leadOwner, setLeadOwner] = useState();
  const [loading, setLoading] = useState(true);
  const [deleteSalaryAdjustId, setDeleteSalaryAdjustId] = useState();
  const [employeeData, setEmplyeeData] = useState();

  useEffect(() => {
    performRequest("GET", "/employeeManagement/getActiveEmployeeList")
      .then((res) => setLeadOwner(res?.data))
      .catch((err) => CustomErrorResponse(err))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    setLoading(true);

    axios
      .get(
        getFilteredURL(
          // `http://localhost:8080/employeeManagement/getAllEmployeeSalaryByNameAndMonth`,
          `https://payroll-817182422433.asia-south1.run.app/employeeManagement/getAllEmployeeSalaryByNameAndMonth`,
          page,
          filters
        ),
        {
          headers: payroleCred,
        }
      )
      .then((res) => {
        if (res.status === 200) {
          setAttendanceData(res.data);
        } else {
          Toast("error", "Error while getting Attendance!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [refresh, page]);

  useEffect(() => {
    if (attendanceData?.employeeData?.id) {
      performRequest(
        "GET",
        `/employeeManagement/getEmployeeManagementById/${attendanceData.employeeData.id}`
      )
        .then((res) => setEmplyeeData(res?.data))
        .catch((err) => CustomErrorResponse(err))
        .finally(() => setLoading(false));
    }
  }, [attendanceData]);

  useEffect(() => {
    if (filters.month) {
      setMonth(filters.month);
    }
  }, [filters]);

  const handelSubmit = (values) => {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    let user = leadOwner.filter((el) => el.id == values.userId);
    values = {
      ...values,
      month: months[+values.month?.split("-")[1] - 1],
      year: values.month?.split("-")[0],
      name: user[0].userName,
      email: user[0].email,
    };
    axios
      .post(
        "https://payroll-817182422433.asia-south1.run.app/employeeManagement/addSalaryAdjust",
        values,
        {
          headers: payroleCred,
        }
      )
      .then((res) => {
        if (res.status === 201) {
          document.getElementById("modal-close").click();
          Toast("success", res.data.message);
          setRefresh(!refresh);
        } else {
          document.getElementById("modal-close").click();
          Toast("error", "Error while updating.");
        }
      })
      .catch((err) => {
        document.getElementById("modal-close").click();
        CustomErrorResponse(err);
      });
  };
  const handelModelOpen = (id) => {
    setDeleteSalaryAdjustId(id);
    document.getElementById("open-modal").click();
  };

  const removeRecord = () => {
    axios
      .delete(
        `https://payroll-817182422433.asia-south1.run.app/employeeManagement/deleteSalaryAdjust/${deleteSalaryAdjustId}`,
        { headers: payroleCred }
      )
      .then((res) => {
        if (res.status === 200) {
          document.getElementById("modal-close").click();
          setDeleteSalaryAdjustId();
          Toast("success", res.data.message);
          setRefresh(!refresh);
        } else {
          document.getElementById("modal-close").click();
          Toast("error", "Error while deleting.");
        }
      })
      .catch((err) => {
        document.getElementById("modal-close").click();
        CustomErrorResponse(err);
      });
  };

  let paybleSalary = 0;
  if (attendanceData?.paybleSalary) {
    paybleSalary += +attendanceData?.paybleSalary;
  }
  if (
    attendanceData?.salaryAdjust?.ammount &&
    attendanceData?.salaryAdjust?.type
  ) {
    attendanceData?.salaryAdjust?.type === "addition"
      ? (paybleSalary += +attendanceData?.salaryAdjust?.ammount)
      : (paybleSalary -= +attendanceData?.salaryAdjust?.ammount);
  }

  const today = new Date();
  const minMonth =
    today.getDate() > 5
      ? today.toISOString().slice(0, 7) // current month
      : new Date(today.setMonth(today.getMonth() - 1))
          .toISOString()
          .slice(0, 7);
  const handleClick = () => {
    navigate("/employee-payslip", {
      state: {
        myProp: {
          ...attendanceData,
          userName: username,
          month: months,
          employeeData: employeeData,
          paybleSalary,
        },
      },
    });
  };

  // const handelEmpinfoSubmit = async (values, actions) => {
  //   try {
  //     setLoading(true);
  //     console.log(values);

  //     const res = axios.post(
  //       "https://payroll-817182422433.asia-south1.run.app/employeeManagement/createEmployeeSalaryInfo",
  //       values,
  //       { headers: payroleCred }
  //     );

  //     if (res.status === 200) {
  //       Toast("success", "Employee Salary Info Created Successfully");
  //       actions.resetForm();
  //       document.getElementById("modal-close").click();
  //     }
  //   } catch (err) {
  //     Toast("error", err?.response?.data?.msg || "Something went wrong");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handelEmpinfoSubmit = async (values, actions) => {
    try {
      // setLoading(true);

      const res = await axios.post(
        "https://payroll-817182422433.asia-south1.run.app/employeeManagement/createEmployeeSalaryInfo",
        values,
        { headers: payroleCred }
      );
      if (res.status === 201) {
        Toast("success", res.data?.message);
        actions.resetForm();
        document.getElementById("modal-close2")?.click();
      }
      if (res?.status === 200) {
        Toast("success", res.data?.message);
        actions.resetForm();
        document.getElementById("modal-close2")?.click();
      }
    } catch (err) {
      CustomErrorResponse(err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none mb-4">
            <div className="row align-items-center">
              <div className="col-md-4">
                <h2 className="page-title mb-1">
                  <FcMoneyTransfer className="fs-2 me-1" /> Employee Salary
                  Management
                </h2>
                <h4 className="text-muted">
                  Calculate & check employee salary
                </h4>
              </div>
              <div className="col-md-8 text-md-end">
                {(store?.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
                  store?.Role === process.env.REACT_APP_ROLE_ADMIN) && (
                  <button
                    className="btn btn-primary me-2"
                    data-bs-toggle="modal"
                    data-bs-target="#modal-emp-info"
                  >
                    <TbAdjustmentsCheck className="me-1" /> EMPLOYEE INFO
                  </button>
                )}
                {(store?.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
                  store?.Role === process.env.REACT_APP_ROLE_ADMIN) && (
                  <button
                    className="btn btn-primary me-2"
                    data-bs-toggle="modal"
                    data-bs-target="#modal-team1"
                  >
                    <TbAdjustmentsCheck className="me-1" /> SALARY UPDATE
                  </button>
                )}
                <button className="btn btn-primary me-2" onClick={handleClick}>
                  <FaFileInvoiceDollar className="me-1" /> PAYSLIP
                </button>
                {(store?.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
                  store?.Role === process.env.REACT_APP_ROLE_ADMIN) && (
                  <button
                    className="btn btn-primary me-2 mt-2 mt-md-0 mt-lg-0 cursor-pointer"
                    onClick={() => navigate("/get-all-employees-salary")}
                  >
                    All Employee Salary
                  </button>
                )}
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-3 col-sm-12">
              <div className="card p-2">
                <div
                  id="faq-1"
                  className="accordion"
                  role="tablist"
                  aria-multiselectable="true"
                >
                  <div>
                    <div className="accordion-header m-0" role="tab">
                      <button
                        className="accordion-button fs-3 d-md-none p-0"
                        data-bs-toggle="collapse"
                        data-bs-target="#faq-1-1"
                      >
                        <h3 className="m-1">Filter result</h3>
                      </button>
                    </div>

                    <div
                      id="faq-1-1"
                      className="accordion-collapse collapse d-md-none"
                      role="tabpanel"
                      data-bs-parent="#faq-1"
                    >
                      <div className="accordion-body pt-0">
                        <div className="row">
                          <div className="col-12">
                            <DynamicFilterSelect
                              label="Search employee:"
                              onChange={(e) => {
                                const { value } = e.target;
                                let lead = leadOwner.find(
                                  (el) => el.id == value
                                );
                                setFilters((prevFilters) => ({
                                  ...prevFilters,
                                  userName: lead.userName,
                                  userId: lead.id,
                                }));
                                setUserName(value);
                              }}
                              value={filters?.userId || ""}
                            >
                              <option value="">select all</option>
                              {store?.Role ===
                                process.env.REACT_APP_ROLE_ADMIN_S ||
                              store?.Role ===
                                process.env.REACT_APP_ROLE_ADMIN ||
                              store?.Role === process.env.REACT_APP_ROLE_HR ||
                              store?.Role ===
                                process.env.REACT_APP_ROLE_ACCOUNTS ? (
                                leadOwner &&
                                leadOwner.map((state, index) => (
                                  <option key={index} value={state?.id}>
                                    {state?.userName}
                                  </option>
                                ))
                              ) : (
                                <option value={store?.Name}>
                                  {store?.Name}
                                </option>
                              )}
                            </DynamicFilterSelect>
                          </div>

                          <div className="col-12">
                            <DynamicFilterInput
                              label="Month (YYYY-MM):"
                              value={filters.month}
                              onChange={(e) => {
                                const { value } = e.target;
                                setFilters((prevFilters) => ({
                                  ...prevFilters,
                                  month: value,
                                }));
                                setMonth(value);
                              }}
                              type="month"
                              max={new Date().toISOString().slice(0, 7)}
                            />
                          </div>
                          <div className="col-12">
                            <div className="row mt-2">
                              <div className="col-6">
                                <button
                                  onClick={() => setRefresh(!refresh)}
                                  className="btn btn-success w-100"
                                >
                                  Apply Filter
                                </button>
                              </div>
                              <div className="col-6">
                                <button
                                  onClick={() => {
                                    setFilters({
                                      startdate: "",
                                      enddate: "",
                                      userName: "",
                                      month: "",
                                    });
                                    setRefresh(!refresh);
                                  }}
                                  className="btn btn-secondary w-100"
                                >
                                  Reset Filter
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-body d-none d-md-block">
                      <div className="row">
                        <h3>Filter result</h3>
                        <div className="col-12">
                          <DynamicFilterSelect
                            label="Search employee:"
                            onChange={(e) => {
                              const { value } = e.target;
                              let lead = leadOwner.find((el) => el.id == value);
                              setFilters((prevFilters) => ({
                                ...prevFilters,
                                userName: lead.userName,
                                userId: lead.id,
                              }));
                              setUserName(value);
                            }}
                            value={filters?.userId || ""}
                          >
                            <option value="">select all</option>
                            {store?.Role ===
                              process.env.REACT_APP_ROLE_ADMIN_S ||
                            store?.Role === process.env.REACT_APP_ROLE_ADMIN ||
                            store?.Role === process.env.REACT_APP_ROLE_HR ||
                            store?.Role ===
                              process.env.REACT_APP_ROLE_ACCOUNTS ? (
                              leadOwner &&
                              leadOwner.map((state, index) => (
                                <option key={index} value={state?.id}>
                                  {state?.userName}
                                </option>
                              ))
                            ) : (
                              <option value={store?.Name}>{store?.Name}</option>
                            )}
                          </DynamicFilterSelect>
                        </div>
                        <div className="col-12">
                          <DynamicFilterInput
                            label="Month (YYYY-MM):"
                            value={filters.month}
                            onChange={(e) => {
                              const { value } = e.target;
                              setFilters((prevFilters) => ({
                                ...prevFilters,
                                month: value,
                              }));
                              setMonth(value);
                            }}
                            type="month"
                            max={new Date().toISOString().slice(0, 7)}
                          />
                        </div>

                        <div className="col-12">
                          <div className="row mt-2">
                            <div className="col-6">
                              <button
                                onClick={() => setRefresh(!refresh)}
                                className="btn btn-success w-100"
                              >
                                Apply Filter
                              </button>
                            </div>
                            <div className="col-6">
                              <button
                                onClick={() => {
                                  setFilters({
                                    startdate: "",
                                    enddate: "",
                                    userName: "",
                                    month: "",
                                  });
                                  setRefresh(!refresh);
                                }}
                                className="btn btn-secondary w-100"
                              >
                                Reset Filter
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card mt-3 p-2">
                <ul>
                  <li className="mt-2">
                    Sunday :{" "}
                    <div
                      style={{ backgroundColor: "#D3D3D3" }}
                      className="avatar avatar-xs"
                      data-demo-color=""
                    ></div>
                  </li>
                  <li className="mt-2">
                    Holliday :{" "}
                    <div
                      style={{ backgroundColor: "#ADD8E6" }}
                      className="avatar avatar-xs"
                      data-demo-color=""
                    ></div>
                  </li>
                  <li className="mt-2">
                    Leave :{" "}
                    <div
                      style={{ backgroundColor: "#E4CFF1" }}
                      className="avatar avatar-xs"
                      data-demo-color=""
                    ></div>
                  </li>
                  <li className="mt-2">
                    Intime + 9 hrs :{" "}
                    <div
                      style={{ backgroundColor: "rgba(0, 128, 0, 0.2)" }}
                      className="avatar avatar-xs"
                      data-demo-color=""
                    ></div>
                  </li>
                  <li className="mt-2">
                    grace period + 9 hrs :{" "}
                    <div
                      style={{ backgroundColor: "rgba(255, 255, 0, 0.2)" }}
                      className="avatar avatar-xs"
                      data-demo-color=""
                    ></div>
                  </li>

                  <li className="mt-2">
                    Intime or grace period or 2nd half :{" "}
                    <div
                      style={{ backgroundColor: "rgba(221, 184, 84, 0.4)" }}
                      className="avatar avatar-xs"
                      data-demo-color=""
                    ></div>
                  </li>
                  <li className="mt-2">
                    Late or not-attended :{" "}
                    <div
                      style={{ backgroundColor: "rgba(224, 109, 109, 0.3)" }}
                      className="avatar avatar-xs"
                      data-demo-color=""
                    ></div>
                  </li>
                  <li className="mt-2">
                    No record :{" "}
                    <div
                      style={{ backgroundColor: "transparent" }}
                      className="avatar avatar-xs"
                      data-demo-color=""
                    ></div>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-lg-9 col-md-8 col-sm-12 mb-4">
              <div className="card shadow-sm">
                <div className="card-body">
                  {leadOwner && attendanceData && (
                    <>
                      <h3 className="card-title mb-3">
                        <FcBusinessman className="me-1 fs-2" />
                        Employee Data
                      </h3>
                      <table className="table table-sm table-borderless">
                        <tbody>
                          <tr>
                            <td>Employee Name</td>
                            <td>
                              {attendanceData?.employeeData?.firstName}{" "}
                              {attendanceData?.employeeData?.lastName}
                            </td>
                          </tr>
                          {store?.Role ===
                            process.env.REACT_APP_ROLE_ADMIN_S && (
                            <tr>
                              <td>Portal Password</td>
                              <td>
                                {attendanceData?.salaryData?.password || "N/A"}
                              </td>
                            </tr>
                          )}
                          <tr>
                            <td>Employee Id</td>
                            <td>{attendanceData?.employeeData?.id || "N/A"}</td>
                          </tr>
                          <tr>
                            <td>Salary per month</td>
                            <td>
                              {attendanceData?.salaryData?.salaryPerMonth ||
                                attendanceData?.employeeData?.salaryPerMonth ||
                                "N/A"}
                            </td>
                          </tr>

                          <tr>
                            <td>Per day salary</td>
                            <td>
                              {attendanceData?.perDaySalary?.toFixed(2) ||
                                "N/A"}
                            </td>
                          </tr>
                          <tr>
                            <td>Half day salary</td>
                            <td>
                              {attendanceData?.halfDaySalary?.toFixed(2) ||
                                "N/A"}
                            </td>
                          </tr>

                          <tr>
                            <td>Available paid leaves</td>
                            <td>
                              {attendanceData?.availablePaidLeaves || "0"} days
                            </td>
                          </tr>
                          <tr>
                            <td>Available extra working days</td>
                            <td>
                              {attendanceData?.availableAdditionalWorkDays ||
                                "0"}{" "}
                              days
                            </td>
                          </tr>
                          <tr>
                            <td colSpan={2}>
                              <hr className="m-0" />
                            </td>
                          </tr>
                          <h3 className="my-1">Data from attendance :</h3>
                          <tr>
                            <td colSpan={2}>
                              <hr className="m-0" />
                            </td>
                          </tr>
                          <tr>
                            <td>Total days in month</td>
                            <td>
                              {attendanceData?.monthTotalDays || "0"} days
                            </td>
                          </tr>
                          <tr>
                            <td>Total Work hours</td>
                            <td>
                              {attendanceData?.totalWorkHr?.toFixed(2) || "N/A"}{" "}
                              hrs
                            </td>
                          </tr>
                          <tr>
                            <td>Total full days (exc. sundays)</td>
                            <td>
                              {attendanceData?.totalFullDaysWithoutSunday ||
                                "0"}{" "}
                              days
                            </td>
                          </tr>

                          <tr>
                            <td>Total half days (exc. sundays)</td>
                            <td>
                              {attendanceData?.totalHalfDaysWithoutSunday ||
                                "0"}{" "}
                              days
                            </td>
                          </tr>
                          <tr>
                            <td>Additional work days (this month)</td>
                            <td>
                              {attendanceData?.additionalWorkDaysCount || "0"}{" "}
                            </td>
                          </tr>
                          <tr>
                            <td>Total holidays in month</td>
                            <td>{attendanceData?.totalWorkHolidays || "0"} </td>
                          </tr>
                          <tr>
                            <td>Total leaves in month</td>
                            <td>
                              {attendanceData?.totalLeavsDays || "0"} leaves
                            </td>
                          </tr>
                          <tr>
                            <td>Total sundays in month</td>
                            <td>{attendanceData?.totalSundays || "N/A"}</td>
                          </tr>
                          <tr>
                            <td>Total payable days</td>
                            <td>
                              {attendanceData?.totalPayableDays || "0"} days
                            </td>
                          </tr>
                          <tr>
                            <td>Salary (inc. sundays)</td>
                            <td>
                              ₹
                              {attendanceData?.totalSalary?.toFixed(2) || "N/A"}
                            </td>
                          </tr>
                          <tr>
                            <td colSpan={2}>
                              <hr className="m-0" />
                            </td>
                          </tr>
                          {attendanceData?.salaryAdjust &&
                            attendanceData?.salaryAdjust?.history?.length >
                              0 && (
                              <>
                                <h3 className="my-1">
                                  Salary adjust history :
                                </h3>
                                <tr>
                                  <td colSpan={2}>
                                    <hr className="m-0" />
                                  </td>
                                </tr>
                                {attendanceData?.salaryAdjust?.history?.map(
                                  (el) => {
                                    return (
                                      <tr>
                                        <td>
                                          Desc.: {el.description}
                                          <br /> Date:{" "}
                                          {extractDate(el.createdAt)}
                                        </td>
                                        <td>
                                          {el.type === "addition" ? "+" : "-"} ₹
                                          {el.amount || "0"}
                                          <br />
                                          {store?.Role ===
                                            process.env
                                              .REACT_APP_ROLE_ADMIN_S && (
                                            <button
                                              onClick={() =>
                                                handelModelOpen(el.id)
                                              }
                                              className="btn btn-sm btn-danger p-0 px-1"
                                            >
                                              Remove
                                            </button>
                                          )}
                                        </td>
                                      </tr>
                                    );
                                  }
                                )}
                                <tr>
                                  <td colSpan={2}>
                                    <hr className="m-0" />
                                  </td>
                                </tr>
                              </>
                            )}

                          <h3 className="my-1">Additional details :</h3>
                          <tr>
                            <td colSpan={2}>
                              <hr className="m-0" />
                            </td>
                          </tr>

                          {attendanceData?.applicablePaidLeaves ? (
                            <tr>
                              <td>Applicable Paid Leaves</td>
                              <td>
                                <span>
                                  + ₹
                                  {(
                                    attendanceData.applicablePaidLeaves *
                                    attendanceData.perDaySalary
                                  ).toFixed(2)}
                                </span>{" "}
                                <small>
                                  ({attendanceData.applicablePaidLeaves} days)
                                </small>
                              </td>
                            </tr>
                          ) : null}

                          {attendanceData?.lateComing &&
                          attendanceData?.lateComing?.lateComingCount ? (
                            <tr>
                              <td>Punctuality Deduction</td>
                              <td>
                                - ₹
                                {Number(
                                  attendanceData.lateComing.lateComingDeduction
                                ).toFixed(2)}{" "}
                                <small>
                                  ({attendanceData.lateComing.deductionDays}{" "}
                                  days /{" "}
                                  {attendanceData.lateComing.lateComingCount}{" "}
                                  late arrivals)
                                </small>
                              </td>
                            </tr>
                          ) : (
                            ""
                          )}
                          {attendanceData?.penultyCount ? (
                            <>
                              <tr>
                                <td>Non-Approved taken leaves</td>
                                <td>
                                  {"-  ₹"}
                                  {(
                                    attendanceData?.penultyCount *
                                    attendanceData?.perDaySalary
                                  ).toFixed(2) || 0}{" "}
                                  ({attendanceData?.penultyCount || "0"} days)
                                </td>
                              </tr>
                            </>
                          ) : (
                            ""
                          )}
                          {attendanceData?.availableAdditionalWorkDays ? (
                            <tr>
                              <td>Applicable extra working days</td>
                              <td>
                                {attendanceData?.applicableExtraDays || "0"}{" "}
                                days
                              </td>
                            </tr>
                          ) : (
                            ""
                          )}
                          {attendanceData?.salaryAdjust &&
                            attendanceData?.salaryAdjust?.type &&
                            attendanceData?.salaryAdjust?.ammount != 0 && (
                              <>
                                <tr>
                                  <td>
                                    {attendanceData?.salaryAdjust?.type ===
                                    "addition"
                                      ? "Salary Addition"
                                      : "Salary Deduction"}
                                  </td>
                                  <td>
                                    {attendanceData?.salaryAdjust?.type ===
                                    "addition"
                                      ? "+ ₹"
                                      : "- ₹"}
                                    {Number(
                                      attendanceData?.salaryAdjust?.ammount ?? 0
                                    ).toFixed(2)}{" "}
                                    (salary adjustment)
                                  </td>
                                </tr>
                              </>
                            )}
                          <tr>
                            <td>Incentive</td>
                            <td>
                              + ₹
                              {Number(
                                attendanceData?.incentiveEmployee ?? 0
                              ).toFixed(2)}
                            </td>
                          </tr>
                          <tr>
                            <td>PT Deductions</td>
                            <td>
                              - ₹
                              {Number(
                                attendanceData?.salaryData
                                  ?.ptDeductionPerMonth ??
                                  attendanceData?.employeeData?.pfptDeduction ??
                                  0
                              ).toFixed(2)}
                            </td>
                          </tr>
                          {attendanceData?.salaryData && (
                            <>
                              <tr>
                                <td>PF Deductions</td>
                                <td>
                                  - ₹
                                  {Number(
                                    attendanceData?.salaryData
                                      ?.pfDeductionPerMonth ?? 0
                                  ).toFixed(2)}
                                </td>
                              </tr>

                              <tr>
                                <td>ESIC Deductions</td>
                                <td>
                                  - ₹
                                  {(
                                    Number(
                                      attendanceData?.salaryData
                                        ?.esicEmployeePerMonth ?? 0
                                    ) +
                                    Number(
                                      attendanceData?.salaryData
                                        ?.esicEmployerPerMonth ?? 0
                                    )
                                  ).toFixed(2)}
                                </td>
                              </tr>

                              <tr>
                                <td>TDS Deductions</td>
                                <td>
                                  - ₹
                                  {(
                                    Number(
                                      attendanceData?.salaryData?.tdsPerYear ??
                                        0
                                    ) / 12
                                  ).toFixed(2)}
                                </td>
                              </tr>
                            </>
                          )}

                          <tr>
                            <td colSpan={2}>
                              <hr className="m-0" />
                            </td>
                          </tr>
                          <tr className="fs-3 fw-bold">
                            <td>Total Salary (inc. incentive & PF/PT)</td>
                            <td>₹{paybleSalary?.toFixed(2) || 0}</td>
                          </tr>
                        </tbody>
                      </table>
                    </>
                  )}
                </div>
              </div>
              {leadOwner && attendanceData && (
                <div className="card shadow-sm mt-4">
                  <EmployeeSalaryTracking
                    leadOwner={leadOwner}
                    employeeData={attendanceData?.employeeData}
                    attendanceData={attendanceData?.calculatedData}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <div
        className="modal modal-blur fade"
        id="modal-team1"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered w-lg-100 w-md-100">
          <div className="modal-dialog modal-dialog-centered w-100">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Adjust Salary Details</h5>
                <span
                  data-bs-toggle="modal"
                  data-bs-target="#modal-team1"
                  id={"open-model"}
                ></span>
                <button
                  type="button"
                  id="modal-close"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              <Formik
                initialValues={salaryAdjustInfo}
                validationSchema={salaryAdjustSchema}
                onSubmit={handelSubmit}
              >
                {(props) => (
                  <Form>
                    <div className="modal-body">
                      <div>
                        <div className="row mb-3">
                          <label className="form-label required col-3">
                            Employee
                          </label>
                          <div className="col-9">
                            <CustomSelect name="userId" type="text">
                              <option value="">select all</option>
                              {leadOwner &&
                                leadOwner.map((state, index) => (
                                  <option key={index} value={state?.id}>
                                    {state?.userName}
                                  </option>
                                ))}
                            </CustomSelect>
                            {props.touched.userId && props.errors.userId && (
                              <p className="text-danger">
                                {props.errors.userId}
                              </p>
                            )}
                          </div>
                        </div>

                        <div className="row mb-3">
                          <label className="form-label required col-3">
                            Month
                          </label>
                          <div className="col-9">
                            <CustomInput
                              name="month"
                              type="month"
                              min={minMonth}
                              max={new Date().toISOString().slice(0, 7)}
                            />
                            {props.touched.month && props.errors.month && (
                              <p className="text-danger">
                                {props.errors.month}
                              </p>
                            )}
                          </div>
                        </div>

                        <div className="row mb-3">
                          <label className="form-label required col-3">
                            Amount
                          </label>
                          <div className="col-9">
                            <CustomInput name="amount" type="number" />
                            {props.touched.amount && props.errors.amount && (
                              <p className="text-danger">
                                {props.errors.amount}
                              </p>
                            )}
                          </div>
                        </div>

                        <div className="row mb-3">
                          <label className="form-label required col-3">
                            Type
                          </label>
                          <div className="col-9">
                            <CustomSelect name="type" type="text">
                              <option value="">Select</option>
                              <option value="addition">Addition</option>
                              <option value="deduction">Deduction</option>
                            </CustomSelect>
                            {props.touched.type && props.errors.type && (
                              <p className="text-danger">{props.errors.type}</p>
                            )}
                          </div>
                        </div>

                        <div className="row mb-3">
                          <label className="form-label required col-3">
                            Description
                          </label>
                          <div className="col-9">
                            <CustomTextArea
                              name="description"
                              type="text"
                              rows="5"
                              cols="200"
                              placeholder="Type amount description here..."
                            />
                            {props.touched.description &&
                              props.errors.description && (
                                <p className="text-danger">
                                  {props.errors.description}
                                </p>
                              )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer bg-transparent">
                      <button
                        type="button"
                        className="btn me-auto disable"
                        data-bs-dismiss="modal"
                        id="model-dismiss"
                      >
                        Close
                      </button>
                      <div className="btn-list justify-content-center">
                        <FormSubmitButton buttonText="salary update" />
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal modal-blur fade"
        id="modal-danger"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-sm modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <span
              id="open-modal"
              data-bs-toggle="modal"
              data-bs-target="#modal-danger"
            ></span>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
            <div className="modal-status bg-warning"></div>
            <div className="modal-body text-center py-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="icon mb-2 text-warning icon-lg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                strokeWidth="2"
                stroke="currentColor"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M10.24 3.957l-8.422 14.06a1.989 1.989 0 0 0 1.7 2.983h16.845a1.989 1.989 0 0 0 1.7 -2.983l-8.423 -14.06a1.989 1.989 0 0 0 -3.4 0z" />
                <path d="M12 9v4" />
                <path d="M12 17h.01" />
              </svg>
              <h3>Are you sure about delete record?</h3>
              <div className="text-muted">
                Do you really want to remove salary adjust record? This process
                cannot be undone.
              </div>
            </div>
            <div className="modal-footer">
              <div className="w-100">
                <div className="row">
                  <div className="col">
                    <button className="btn w-100" data-bs-dismiss="modal">
                      Cancel
                    </button>
                  </div>
                  <div className="col">
                    <button
                      className="btn btn-danger w-100"
                      data-bs-dismiss="modal"
                      onClick={() => removeRecord()}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal modal-blur fade"
        id="modal-emp-info"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered w-lg-100 w-md-100">
          <div className="modal-dialog modal-dialog-centered w-100">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Employee Details</h5>
                <span
                  data-bs-toggle="modal"
                  data-bs-target="#modal-emp-info"
                  id={"open-model"}
                ></span>
                <button
                  type="button"
                  id="modal-close2"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              <Formik
                initialValues={employeeSalaryInfo}
                validationSchema={salaryEmpInfoSchema}
                onSubmit={handelEmpinfoSubmit}
              >
                {(props) => (
                  <Form>
                    <div className="modal-body">
                      <div>
                        <div className="row mb-3">
                          <label className="form-label required col-3">
                            Employee
                          </label>
                          <div className="col-9">
                            <CustomSelect
                              id={new Date()}
                              name="email"
                              type="text"
                              onChange={(e) => {
                                if (!e.target.value) {
                                  props.setFieldValue("userName", "");
                                  props.setFieldValue("email", "");
                                } else {
                                  let user = leadOwner.find(
                                    (el) => el.email === e.target.value
                                  );
                                  props.setFieldValue(
                                    "userName",
                                    user.userName
                                  );
                                  props.setFieldValue("email", user.email);
                                }
                              }}
                            >
                              <option value="">select all</option>

                              {leadOwner &&
                                leadOwner.map((state, index) => (
                                  <option key={index} value={state?.email}>
                                    {state?.userName}
                                  </option>
                                ))}
                            </CustomSelect>
                            {props.touched.userName &&
                              props.errors.userName && (
                                <p className="text-danger">
                                  {props.errors.userName}
                                </p>
                              )}{" "}
                            {props.touched.email && props.errors.email && (
                              <p className="text-danger">
                                {props.errors.email}
                              </p>
                            )}
                          </div>
                        </div>

                        <div className="row mb-3">
                          <label className="form-label required col-3">
                            Salary Per Year
                          </label>
                          <div className="col-9">
                            <CustomInput name="salaryPerYear" type="number" />
                            {props.touched.salaryPerYear &&
                              props.errors.salaryPerYear && (
                                <p className="text-danger">
                                  {props.errors.salaryPerYear}
                                </p>
                              )}
                          </div>
                        </div>

                        <div className="row mb-3">
                          <label className="form-label col-3">Password</label>
                          <div className="col-9">
                            <CustomInput name="password" type="text" />
                            {props.touched.password &&
                              props.errors.password && (
                                <p className="text-danger">
                                  {props.errors.password}
                                </p>
                              )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer bg-transparent">
                      <button
                        type="button"
                        className="btn me-auto disable"
                        data-bs-dismiss="modal"
                        id="model-dismiss"
                      >
                        Close
                      </button>
                      <div className="btn-list justify-content-center">
                        <FormSubmitButton buttonText="salary update" />
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployeeSalary;
